import React from "react";
import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Framework/helpers/BreakpointHelper";
export const Burger = styled.div`
	border-radius: 50px;
	width: 60px;
	height: 60px;
	display: flex;
	justify-content: center;
	align-items: center;
	border: ${({ theme }) => `2px solid ${theme.colors.primary}`};
	background-color: ${({ theme }) => theme.colors.lightgrey};
	position: fixed;
	top: 10px;
	z-index: 1000;
	right: 10px;

	${media.greaterThan(breakpoints.ipadPro)`
		display:none;	
	`}
`;
export const BurgerButtonWrapper = styled.div`
	& {
		width: 30px;
		height: 18px;
		position: relative;
		-webkit-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
		-webkit-transition: 0.6s ease;
		-moz-transition: 0.6s ease;
		-o-transition: 0.6s ease;
		transition: 0.6s ease;
		cursor: pointer;
	}

	span {
		display: block;
		position: absolute;
		height: 3px;
		width: 100%;
		background: ${({ theme }) => theme.colors.black};
		border-radius: 2.5px;
		opacity: 1;
		left: 0;
		-webkit-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
		-webkit-transition: 0.35s ease;
		-moz-transition: 0.35s ease;
		-o-transition: 0.35s ease;
		transition: 0.35s ease;
	}
	.open {
		height: 3px;
	}
	span:nth-child(1) {
		top: 0px;
	}

	span:nth-child(2),
	span:nth-child(3) {
		top: 7px;
	}

	span:nth-child(4) {
		top: 14px;
	}

	.open:nth-child(1) {
		top: 7px;
		width: 0%;
		left: 50%;
	}

	.open:nth-child(2) {
		-webkit-transform: rotate(45deg);
		-moz-transform: rotate(45deg);
		-o-transform: rotate(45deg);
		transform: rotate(45deg);
	}

	.open:nth-child(3) {
		-webkit-transform: rotate(-45deg);
		-moz-transform: rotate(-45deg);
		-o-transform: rotate(-45deg);
		transform: rotate(-45deg);
	}

	.open:nth-child(4) {
		top: 7px;
		width: 0%;
		left: 50%;
	}
`;
